import styled from "@emotion/styled";
import { useLocation, useNavigate } from "react-router-dom";
import { useExpenseStore, useRevenueStore } from "../store";

const Container = styled.div`
  background-color: #fafafa;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 8px;
`;

const Item = styled.div`
  padding: 12px 24px;
  background-color: ${({ active, theme }) =>
    active ? theme.palette.primary.main : "transparent"};
  color: ${({ active }) => (active ? "#fff" : "#000")};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ active, theme }) =>
      active ? theme.palette.primary.main : "#f0f0f0"};
  }
`;

export const Menu = () => {
  const openRecordRevenueModal = useRevenueStore(
    state => state.openRecordRevenueModal
  );
  const openRecordExpenseModal = useExpenseStore(
    state => state.openRecordExpenseModal
  );

  const items = [
    {
      name: "Overview",
      translation: "Overview",
      url: "/finances/temp/overview"
    },
    {
      name: "Revenue",
      translation: "Revenue",
      url: "/finances/temp/revenue",
      subItems: [
        {
          name: "Record Revenue",
          translation: "Record Revenue",
          onClick: () => openRecordRevenueModal()
        },
        {
          name: "Revenue Setting",
          translation: "Revenue Setting",
          onClick: () => navigate("/finances/temp/revenue/settings")
        },
        {
          name: "Cheque Reconcile",
          translation: "Cheque Reconcile",
          onClick: () => navigate("/finances/temp/revenue/cheque-reconcile")
        }
      ]
    },
    {
      name: "Expense",
      translation: "Expense",
      url: "/finances/temp/expense",
      subItems: [
        {
          name: "Record Expense",
          translation: "Record Expense",
          onClick: () => openRecordExpenseModal()
        },
        {
          name: "Expense Setting",
          translation: "Expense Setting",
          onClick: () => navigate("/finances/temp/expense/settings")
        },
        {
          name: "Requisition",
          translation: "Requisition",
          onClick: () => navigate("/finances/temp/expense/requisition")
        }
      ]
    },
    {
      name: "Journal Entry",
      translation: "Journal Entry",
      url: "/finances/temp/journal-entries"
    },
    {
      name: "Pledge",
      translation: "Pledge",
      url: "/finances/temp/pledge",
      subItems: []
    },
    { name: "Budget", translation: "Budget", url: "/finances/temp/budget" },
    { name: "Report", translation: "Report", url: "/finances/temp/report" },
    { name: "Bank", translation: "Bank", url: "/finances/temp/bank" },
    { name: "Setting", translation: "Setting", url: "/finances/temp/setting" }
  ];
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <Container>
      {items.map(item => (
        <Item
          key={item.name}
          active={pathname.includes(item.url)}
          onClick={() => navigate(item.url)}
        >
          <span>{item.translation}</span>
        </Item>
      ))}
    </Container>
  );
};
